import * as React from 'react';

import * as classNames from "classnames";
import './CountriesPage.scss';

import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";

import ReactSelectClass from "react-select";

import ReactTable, { Column, RowInfo } from 'react-table';



import * as ReactTooltip from 'react-tooltip';
import Alert from 'react-s-alert';

import { DefaultLayout, RestrictedLayout, UnrestrictedLayout, SubMenu } from "../../../components/layouts/index";

import * as CountryActions from '../../../actions/countries';
import * as PagingActions from '../../../actions/pages/pagingPage';

import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { convertToShortDateString, convertToDateTimeString, convertToApproximateDateString } from "../../../helpers/date";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { ILinkProps } from "../../../components/routing/Link";
import { INavItem } from "../../../components/layouts/NavMenu/NavMenu";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import { setModalTitle } from "../../../helpers/modalHelper";
import { Modal, NotificationAlert } from "../../../components/common/index";

import * as AuthenticationHelper from '../../../helpers/authentication';
import * as AuthorisationDefinitions from '../../../constants/authorisationDefinitions';
import { ModalSize } from '../../../enumerations/ModalSize';
import { Form, actions, Control } from 'react-redux-form';
import { TextAreaFormInput, FormFilterInput } from '../../../components/form';

import { LookupsLayout } from '../../index';

interface ICountriesPageProps {

    location: Location;
    history: History;

    // From state
    countries: Dtos.Country[];
    formFilter: IFormFilter;
    formLength: number;

    loadingCountries: boolean;
    loadCountriesSuccess: boolean;
    loadCountriesFailure: boolean;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    formRoles?: Dtos.RoleType[];

    pageSize: number;
}

interface ICountriesPageActions {
    clearCountries: CountryActions.ICountryClearActionCreator;
    loadCountries: CountryActions.ICountryLoadActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    filter: CountryActions.ICountryFilterActionCreator;

    setPageSize: PagingActions.IPagingPageSizeChangedStateActionCreator;
}

type CountriesPageProps = ICountriesPageProps & ICountriesPageActions;

const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex"
const tableStyleClass: React.CSSProperties = {
    textAlign: "left",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer"
}

class CountriesPage extends React.PureComponent<CountriesPageProps, any> {

    constructor(props: CountriesPageProps) {
        super(props);

        this.clearCountries = this.clearCountries.bind(this);
    }

    componentDidMount() {
        const {
            loadCountries
        } = this.props;

        loadCountries();
    }

    componentWillReceiveProps(nextProps: CountriesPageProps) {
    }

    componentDidUpdate(prevProps: CountriesPageProps, prevState) {
        const {
            navigateReplace
        } = this.props
    }

    componentWillUpdate(nextProps: CountriesPageProps) {
    }

    componentWillUnmount() {
        this.clearCountries();
    }

    clearCountries() {
        this.props.clearCountries();
    }

    showCountries(): boolean {
        const {
            loadingCountries,
            loadCountriesSuccess
        } = this.props

        if (!loadingCountries && loadCountriesSuccess) {
            return true;
        }

        return false;
    }

    render() {

        const {
            loadingCountries
        } = this.props;


        return <LookupsLayout loading={loadingCountries} permission={Dtos.Permission.CountriesView}>
            {this.renderContent()}
        </LookupsLayout>;
    }

    renderContent() {
        const {
            formRoles,
            permissions
        } = this.props;

        return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Countries</h2>
                </div>
                <div className="col-6" style={{ textAlign: 'right' }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.CountriesCreate) && (
                        <Link className={"btn btn-primary"} url={"/settings/general/countries/create"}>Create</Link>
                    )}
                </div>
            </div>
            {
                !this.showCountries() ?
                    "Loading Countries" :
                    null
            }
            {
                this.showCountries() ?
                    <div className="patient-tables mt-2">
                        {
                            this.createTable()
                        }
                    </div> :
                    null
            }
        </div>
    }

    createTable() {

        const {
            countries,
            pageSize,
            setPageSize,
            formRoles
        } = this.props

        if (!countries || countries.length == 0) {
            return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no countries to view.</span>
            </div>
        }

        const showPagination = countries.length > pageSize;

        return <div className="table-wrapper mb-3">
            <ReactTable
                data={countries}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                defaultPageSize={showPagination ? pageSize : countries.length}
                pageSize={showPagination ? pageSize : countries.length}
                showPagination={showPagination}
                className="-striped -highlight -clickable mb-3"
                noDataText="There are currently no countries to display"
                resizable={false}
                onPageSizeChange={val => setPageSize(val)}
                getTdProps={(state, rowInfo: RowInfo, column, instance) => {
                    return {
                        onClick: (e, handleOriginal) => {
                                const url: string = "/settings/general/countries/" + rowInfo.original.id;
                                this.props.navigate(url);

                                if (handleOriginal) {
                                    handleOriginal()
                                }
                        }
                    }
                }}
                columns={[
                    {
                        id: "id",
                        Header: ' ',
                        accessor: "id",
                        className: "d-flex align-items-center justify-content-center",
                        maxWidth: 50,
                        Cell: (props) => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
                    },
                    {
                        id: "value",
                        Header: 'Name',
                        accessor: 'value',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left"
                    }
                ]}
            />
        </div>

    }

}

const mapStateToProps = (state: ITmdState, ownProps: CountriesPageProps): ICountriesPageProps => {
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
    return {

        history: ownProps.history,
        location: state.routing.location,

        countries: state.countries.formFilteredData!,
        formFilter: state.countries.formFilter,
        formLength: state.countries.formLength,

        loadingCountries: state.countries.loadState && state.countries.loadState.status == RequestState.Pending,
        loadCountriesSuccess: state.countries.loadState && state.countries.loadState.status == RequestState.Success,
        loadCountriesFailure: state.countries.loadState && state.countries.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        formRoles: state.user.formRoles,

        pageSize: state.pagingPage.pageSize
    };
};

const mapDispatchToProps = (dispatch): ICountriesPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadCountries: bindActionCreators(CountryActions.LoadCountry, dispatch),
        clearCountries: bindActionCreators(CountryActions.Clear, dispatch),

        filter: bindActionCreators(CountryActions.Filter, dispatch),

        setPageSize: bindActionCreators(PagingActions.PageSizeChanged, dispatch)
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(CountriesPage);
